 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import INDIANWARVETERANS_COVER from '@/components/IndianWarVeterans_cover'
 import INDIANWARVETERANS_TITLE from '@/components/IndianWarVeterans_title'
 import INDIANWARVETERANS_COPYRIGHTPAGE from '@/components/IndianWarVeterans_copyrightPage'
 import INDIANWARVETERANS_DEDICATION from '@/components/IndianWarVeterans_dedication'
 import INDIANWARVETERANS_BOOKSBY from '@/components/IndianWarVeterans_booksby'
 import INDIANWARVETERANS_TOC from '@/components/IndianWarVeterans_toc'
 import INDIANWARVETERANS_DEDICATION1 from '@/components/IndianWarVeterans_dedication1'
 import INDIANWARVETERANS_PREFACE from '@/components/IndianWarVeterans_preface'
 import INDIANWARVETERANS_INTRODUCTION from '@/components/IndianWarVeterans_introduction'
 import INDIANWARVETERANS_INTRODUCTION1 from '@/components/IndianWarVeterans_introduction1'
 import INDIANWARVETERANS_INTRODUCTION2 from '@/components/IndianWarVeterans_introduction2'
 import INDIANWARVETERANS_INTRODUCTION3 from '@/components/IndianWarVeterans_introduction3'
 import INDIANWARVETERANS_INTRODUCTION4 from '@/components/IndianWarVeterans_introduction4'
 import INDIANWARVETERANS_INTRODUCTION5 from '@/components/IndianWarVeterans_introduction5'
 import INDIANWARVETERANS_INTRODUCTION6 from '@/components/IndianWarVeterans_introduction6'
 import INDIANWARVETERANS_INTRODUCTION7 from '@/components/IndianWarVeterans_introduction7'
 import INDIANWARVETERANS_INTRODUCTION8 from '@/components/IndianWarVeterans_introduction8'
 import INDIANWARVETERANS_INTRODUCTION9 from '@/components/IndianWarVeterans_introduction9'
 import INDIANWARVETERANS_INTRODUCTION10 from '@/components/IndianWarVeterans_introduction10'
 import INDIANWARVETERANS_INTRODUCTION11 from '@/components/IndianWarVeterans_introduction11'
 import INDIANWARVETERANS_INTRODUCTION12 from '@/components/IndianWarVeterans_introduction12'
 import INDIANWARVETERANS_INTRODUCTION13 from '@/components/IndianWarVeterans_introduction13'
 import INDIANWARVETERANS_INTRODUCTION14 from '@/components/IndianWarVeterans_introduction14'
 import INDIANWARVETERANS_INTRODUCTION15 from '@/components/IndianWarVeterans_introduction15'
 import INDIANWARVETERANS_INTRODUCTION16 from '@/components/IndianWarVeterans_introduction16'
 import INDIANWARVETERANS_PART1 from '@/components/IndianWarVeterans_part1'
 import INDIANWARVETERANS_P11 from '@/components/IndianWarVeterans_p11'
 import INDIANWARVETERANS_P12 from '@/components/IndianWarVeterans_p12'
 import INDIANWARVETERANS_P13 from '@/components/IndianWarVeterans_p13'
 import INDIANWARVETERANS_P14 from '@/components/IndianWarVeterans_p14'
 import INDIANWARVETERANS_P15 from '@/components/IndianWarVeterans_p15'
 import INDIANWARVETERANS_P16 from '@/components/IndianWarVeterans_p16'
 import INDIANWARVETERANS_P17 from '@/components/IndianWarVeterans_p17'
 import INDIANWARVETERANS_P18 from '@/components/IndianWarVeterans_p18'
 import INDIANWARVETERANS_P19 from '@/components/IndianWarVeterans_p19'
 import INDIANWARVETERANS_P110 from '@/components/IndianWarVeterans_p110'
 import INDIANWARVETERANS_P111 from '@/components/IndianWarVeterans_p111'
 import INDIANWARVETERANS_P112 from '@/components/IndianWarVeterans_p112'
 import INDIANWARVETERANS_P113 from '@/components/IndianWarVeterans_p113'
 import INDIANWARVETERANS_P114 from '@/components/IndianWarVeterans_p114'
 import INDIANWARVETERANS_P115 from '@/components/IndianWarVeterans_p115'
 import INDIANWARVETERANS_P116 from '@/components/IndianWarVeterans_p116'
 import INDIANWARVETERANS_P117 from '@/components/IndianWarVeterans_p117'
 import INDIANWARVETERANS_P118 from '@/components/IndianWarVeterans_p118'
 import INDIANWARVETERANS_P119 from '@/components/IndianWarVeterans_p119'
 import INDIANWARVETERANS_P120 from '@/components/IndianWarVeterans_p120'
 import INDIANWARVETERANS_P121 from '@/components/IndianWarVeterans_p121'
 import INDIANWARVETERANS_P122 from '@/components/IndianWarVeterans_p122'
 import INDIANWARVETERANS_PART2 from '@/components/IndianWarVeterans_part2'
 import INDIANWARVETERANS_P21 from '@/components/IndianWarVeterans_p21'
 import INDIANWARVETERANS_P22 from '@/components/IndianWarVeterans_p22'
 import INDIANWARVETERANS_P23 from '@/components/IndianWarVeterans_p23'
 import INDIANWARVETERANS_P24 from '@/components/IndianWarVeterans_p24'
 import INDIANWARVETERANS_P25 from '@/components/IndianWarVeterans_p25'
 import INDIANWARVETERANS_P26 from '@/components/IndianWarVeterans_p26'
 import INDIANWARVETERANS_P27 from '@/components/IndianWarVeterans_p27'
 import INDIANWARVETERANS_P28 from '@/components/IndianWarVeterans_p28'
 import INDIANWARVETERANS_P29 from '@/components/IndianWarVeterans_p29'
 import INDIANWARVETERANS_P210 from '@/components/IndianWarVeterans_p210'
 import INDIANWARVETERANS_P211 from '@/components/IndianWarVeterans_p211'
 import INDIANWARVETERANS_P212 from '@/components/IndianWarVeterans_p212'
 import INDIANWARVETERANS_P213 from '@/components/IndianWarVeterans_p213'
 import INDIANWARVETERANS_P214 from '@/components/IndianWarVeterans_p214'
 import INDIANWARVETERANS_P215 from '@/components/IndianWarVeterans_p215'
 import INDIANWARVETERANS_P216 from '@/components/IndianWarVeterans_p216'
 import INDIANWARVETERANS_P217 from '@/components/IndianWarVeterans_p217'
 import INDIANWARVETERANS_P218 from '@/components/IndianWarVeterans_p218'
 import INDIANWARVETERANS_P219 from '@/components/IndianWarVeterans_p219'
 import INDIANWARVETERANS_P220 from '@/components/IndianWarVeterans_p220'
 import INDIANWARVETERANS_P221 from '@/components/IndianWarVeterans_p221'
 import INDIANWARVETERANS_P222 from '@/components/IndianWarVeterans_p222'
 import INDIANWARVETERANS_P223 from '@/components/IndianWarVeterans_p223'
 import INDIANWARVETERANS_P224 from '@/components/IndianWarVeterans_p224'
 import INDIANWARVETERANS_P225 from '@/components/IndianWarVeterans_p225'
 import INDIANWARVETERANS_P226 from '@/components/IndianWarVeterans_p226'
 import INDIANWARVETERANS_P227 from '@/components/IndianWarVeterans_p227'
 import INDIANWARVETERANS_P228 from '@/components/IndianWarVeterans_p228'
 import INDIANWARVETERANS_P229 from '@/components/IndianWarVeterans_p229'
 import INDIANWARVETERANS_P230 from '@/components/IndianWarVeterans_p230'
 import INDIANWARVETERANS_P231 from '@/components/IndianWarVeterans_p231'
 import INDIANWARVETERANS_P232 from '@/components/IndianWarVeterans_p232'
 import INDIANWARVETERANS_P233 from '@/components/IndianWarVeterans_p233'
 import INDIANWARVETERANS_P234 from '@/components/IndianWarVeterans_p234'
 import INDIANWARVETERANS_P235 from '@/components/IndianWarVeterans_p235'
 import INDIANWARVETERANS_P236 from '@/components/IndianWarVeterans_p236'
 import INDIANWARVETERANS_P237 from '@/components/IndianWarVeterans_p237'
 import INDIANWARVETERANS_P238 from '@/components/IndianWarVeterans_p238'
 import INDIANWARVETERANS_P239 from '@/components/IndianWarVeterans_p239'
 import INDIANWARVETERANS_P240 from '@/components/IndianWarVeterans_p240'
 import INDIANWARVETERANS_P241 from '@/components/IndianWarVeterans_p241'
 import INDIANWARVETERANS_P242 from '@/components/IndianWarVeterans_p242'
 import INDIANWARVETERANS_P243 from '@/components/IndianWarVeterans_p243'
 import INDIANWARVETERANS_P244 from '@/components/IndianWarVeterans_p244'
 import INDIANWARVETERANS_P245 from '@/components/IndianWarVeterans_p245'
 import INDIANWARVETERANS_P246 from '@/components/IndianWarVeterans_p246'
 import INDIANWARVETERANS_P247 from '@/components/IndianWarVeterans_p247'
 import INDIANWARVETERANS_P248 from '@/components/IndianWarVeterans_p248'
 import INDIANWARVETERANS_P249 from '@/components/IndianWarVeterans_p249'
 import INDIANWARVETERANS_P250 from '@/components/IndianWarVeterans_p250'
 import INDIANWARVETERANS_P251 from '@/components/IndianWarVeterans_p251'
 import INDIANWARVETERANS_P252 from '@/components/IndianWarVeterans_p252'
 import INDIANWARVETERANS_P253 from '@/components/IndianWarVeterans_p253'
 import INDIANWARVETERANS_P254 from '@/components/IndianWarVeterans_p254'
 import INDIANWARVETERANS_P255 from '@/components/IndianWarVeterans_p255'
 import INDIANWARVETERANS_P256 from '@/components/IndianWarVeterans_p256'
 import INDIANWARVETERANS_P257 from '@/components/IndianWarVeterans_p257'
 import INDIANWARVETERANS_SUGGESTEDREADING from '@/components/IndianWarVeterans_suggestedReading'
 import INDIANWARVETERANS_INDEX from '@/components/IndianWarVeterans_index'
 import INDIANWARVETERANS_ABOUTTHEAUTHOR from '@/components/IndianWarVeterans_abouttheauthor'
 import INDIANWARVETERANS_NOTES from '@/components/IndianWarVeterans_notes'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/IndianWarVeterans_cover",
 			"name" : "IndianWarVeterans_cover",
 			"component" : INDIANWARVETERANS_COVER
 		},
 		{
 			"path" : "/IndianWarVeterans_title",
 			"name" : "IndianWarVeterans_title",
 			"component" : INDIANWARVETERANS_TITLE
 		},
 		{
 			"path" : "/IndianWarVeterans_copyrightPage",
 			"name" : "IndianWarVeterans_copyrightPage",
 			"component" : INDIANWARVETERANS_COPYRIGHTPAGE
 		},
 		{
 			"path" : "/IndianWarVeterans_dedication",
 			"name" : "IndianWarVeterans_dedication",
 			"component" : INDIANWARVETERANS_DEDICATION
 		},
 		{
 			"path" : "/IndianWarVeterans_booksby",
 			"name" : "IndianWarVeterans_booksby",
 			"component" : INDIANWARVETERANS_BOOKSBY
 		},
 		{
 			"path" : "/IndianWarVeterans_toc",
 			"name" : "IndianWarVeterans_toc",
 			"component" : INDIANWARVETERANS_TOC
 		},
 		{
 			"path" : "/IndianWarVeterans_dedication1",
 			"name" : "IndianWarVeterans_dedication1",
 			"component" : INDIANWARVETERANS_DEDICATION1
 		},
 		{
 			"path" : "/IndianWarVeterans_preface",
 			"name" : "IndianWarVeterans_preface",
 			"component" : INDIANWARVETERANS_PREFACE
 		},
 		{
 			"path" : "/IndianWarVeterans_introduction",
 			"name" : "IndianWarVeterans_introduction",
 			"component" : INDIANWARVETERANS_INTRODUCTION
 		},
 		{
 			"path" : "/IndianWarVeterans_introduction1",
 			"name" : "IndianWarVeterans_introduction1",
 			"component" : INDIANWARVETERANS_INTRODUCTION1
 		},
 		{
 			"path" : "/IndianWarVeterans_introduction2",
 			"name" : "IndianWarVeterans_introduction2",
 			"component" : INDIANWARVETERANS_INTRODUCTION2
 		},
 		{
 			"path" : "/IndianWarVeterans_introduction3",
 			"name" : "IndianWarVeterans_introduction3",
 			"component" : INDIANWARVETERANS_INTRODUCTION3
 		},
 		{
 			"path" : "/IndianWarVeterans_introduction4",
 			"name" : "IndianWarVeterans_introduction4",
 			"component" : INDIANWARVETERANS_INTRODUCTION4
 		},
 		{
 			"path" : "/IndianWarVeterans_introduction5",
 			"name" : "IndianWarVeterans_introduction5",
 			"component" : INDIANWARVETERANS_INTRODUCTION5
 		},
 		{
 			"path" : "/IndianWarVeterans_introduction6",
 			"name" : "IndianWarVeterans_introduction6",
 			"component" : INDIANWARVETERANS_INTRODUCTION6
 		},
 		{
 			"path" : "/IndianWarVeterans_introduction7",
 			"name" : "IndianWarVeterans_introduction7",
 			"component" : INDIANWARVETERANS_INTRODUCTION7
 		},
 		{
 			"path" : "/IndianWarVeterans_introduction8",
 			"name" : "IndianWarVeterans_introduction8",
 			"component" : INDIANWARVETERANS_INTRODUCTION8
 		},
 		{
 			"path" : "/IndianWarVeterans_introduction9",
 			"name" : "IndianWarVeterans_introduction9",
 			"component" : INDIANWARVETERANS_INTRODUCTION9
 		},
 		{
 			"path" : "/IndianWarVeterans_introduction10",
 			"name" : "IndianWarVeterans_introduction10",
 			"component" : INDIANWARVETERANS_INTRODUCTION10
 		},
 		{
 			"path" : "/IndianWarVeterans_introduction11",
 			"name" : "IndianWarVeterans_introduction11",
 			"component" : INDIANWARVETERANS_INTRODUCTION11
 		},
 		{
 			"path" : "/IndianWarVeterans_introduction12",
 			"name" : "IndianWarVeterans_introduction12",
 			"component" : INDIANWARVETERANS_INTRODUCTION12
 		},
 		{
 			"path" : "/IndianWarVeterans_introduction13",
 			"name" : "IndianWarVeterans_introduction13",
 			"component" : INDIANWARVETERANS_INTRODUCTION13
 		},
 		{
 			"path" : "/IndianWarVeterans_introduction14",
 			"name" : "IndianWarVeterans_introduction14",
 			"component" : INDIANWARVETERANS_INTRODUCTION14
 		},
 		{
 			"path" : "/IndianWarVeterans_introduction15",
 			"name" : "IndianWarVeterans_introduction15",
 			"component" : INDIANWARVETERANS_INTRODUCTION15
 		},
 		{
 			"path" : "/IndianWarVeterans_introduction16",
 			"name" : "IndianWarVeterans_introduction16",
 			"component" : INDIANWARVETERANS_INTRODUCTION16
 		},
 		{
 			"path" : "/IndianWarVeterans_part1",
 			"name" : "IndianWarVeterans_part1",
 			"component" : INDIANWARVETERANS_PART1
 		},
 		{
 			"path" : "/IndianWarVeterans_p11",
 			"name" : "IndianWarVeterans_p11",
 			"component" : INDIANWARVETERANS_P11
 		},
 		{
 			"path" : "/IndianWarVeterans_p12",
 			"name" : "IndianWarVeterans_p12",
 			"component" : INDIANWARVETERANS_P12
 		},
 		{
 			"path" : "/IndianWarVeterans_p13",
 			"name" : "IndianWarVeterans_p13",
 			"component" : INDIANWARVETERANS_P13
 		},
 		{
 			"path" : "/IndianWarVeterans_p14",
 			"name" : "IndianWarVeterans_p14",
 			"component" : INDIANWARVETERANS_P14
 		},
 		{
 			"path" : "/IndianWarVeterans_p15",
 			"name" : "IndianWarVeterans_p15",
 			"component" : INDIANWARVETERANS_P15
 		},
 		{
 			"path" : "/IndianWarVeterans_p16",
 			"name" : "IndianWarVeterans_p16",
 			"component" : INDIANWARVETERANS_P16
 		},
 		{
 			"path" : "/IndianWarVeterans_p17",
 			"name" : "IndianWarVeterans_p17",
 			"component" : INDIANWARVETERANS_P17
 		},
 		{
 			"path" : "/IndianWarVeterans_p18",
 			"name" : "IndianWarVeterans_p18",
 			"component" : INDIANWARVETERANS_P18
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js